
    
    <template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_comment_reports" autocomplete="off">
                <v-layout row wrap>
                    
        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="date" v-model="comment_reports.comment_report_date" :label="$store.getters.lang.data.comment_report_date"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        



            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="reports" v-model="comment_reports.report_id" outlined  item-text="report_id"
                            item-value="report_id" :return-object="false" :label="$store.getters.lang.data.report_id">
                        </v-select>
                        </v-flex>
            

            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="comments" v-model="comment_reports.comment_id" outlined  item-text="comment_id"
                            item-value="comment_id" :return-object="false" :label="$store.getters.lang.data.comment_id">
                        </v-select>
                        </v-flex>
                
    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1"  type="submit" x-large>{{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>    
                </v-layout>
            </form>
        </v-container>
        
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/comment_reports'
    export default {
        data() {
            return {
                comment_reports: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {
            
                    comments (){
                        return this.$store.getters.comments
                    },
                    
                    reports (){
                        return this.$store.getters.reports
                    },
                    
            
        },
        methods: {
            get_comment_reports() {
                this.loading = true
                controller.getOne(this.id).then(r =>{
                    this.comment_reports = r.data.row
                    this.loading = false
                }).catch(e =>{
                    console.log(e);
                })
            },
            update_comment_reports() {
                controller.update_comment_reports(this.comment_reports).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },
            
        },
        mounted() {
            this.id = this.$route.params.id
            this.get_comment_reports()
        },
    }
</script>
    
    